import React, { useMemo } from "react";
import { IChatMessage } from "common/broadcast/_stores/chat/interfaces";
import { languageStore } from "library/core/stores/language/LanguageStore";
import CustomIcon from "library/components/_tailwind/icon/icons";
import AiChatStore from "common/broadcast/_stores/ai-chat/AiChatStore";
import { inject, observer } from "mobx-react";

type Props = {
  message: IChatMessage;
  aiChatStore?: AiChatStore;
};

const ChatMessageGift: React.ComponentType<Props> = ({
  message,
  aiChatStore,
}) => {
  const { intl } = languageStore!;
  const backgroundImage = "linear-gradient(90deg, #2abd76 0%, #124a87 100% )";

  const isAiEnabled = aiChatStore!.isUiVisible;

  const cleanUsername = useMemo(() => {
    if (!message.from) return "";
    if (message.from.includes("ffadult") || message.from.includes("bdsm")) {
      return message.from.split(/_/)[0];
    }
    return message.from.split(/\+|@/)[0];
  }, [message?.from]);

  return (
    <div className='ChatItem__box' style={{ backgroundImage }}>
      <img
        src={message.image || "https://s3.amazonaws.com/upload.uxpin/files/168180/173507/virtual_gift_vdaybearbundle-a333a8.png"}
        alt='Token'
        style={{ width: 40, height: 40, objectFit: "contain" }}
      />
      <span data-testid={"chat-message-gift"}>
        {intl.formatMessage(
          {
            id: `broadcast.chatItem.hasSentYouGift`,
            defaultMessage: `{chatfrom} has sent you a gift of {chatValue} tokens`,
          },
          { chatfrom: message.from, chatValue: message.value }
        )}
      </span>
      {isAiEnabled && (
        <span
          style={{
            fontSize: "0.875rem",
            color: "var(--pink-color)",
            display: "inline-flex",
            verticalAlign: "middle",
            cursor: "pointer",
            marginLeft: "4px",
            opacity: 0.6,
          }}
          onClick={() =>
            aiChatStore?.requestTransactionRecommendation(
              cleanUsername,
              `[SYSTEM] ${cleanUsername} sent a gift: ${message.value || 0} tokens`
            
            )
          }>
          <CustomIcon name={"auto_awesome"} />
        </span>
      )}
    </div>
  );
};

export default inject(
  "aiChatStore"
)(observer(ChatMessageGift));
